/**
 * Step Indicator Component
 * Shows progress through multi-step deposit flow
 */

interface Step {
  number: number
  title: string
  status: 'pending' | 'active' | 'completed'
}

interface StepIndicatorProps {
  steps: Step[]
}

export function StepIndicator({ steps }: StepIndicatorProps) {
  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center flex-1">
            {/* Step Circle */}
            <div className="flex flex-col items-center">
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm
                  transition-all duration-300
                  ${
                    step.status === 'completed'
                      ? 'bg-green-500 text-white'
                      : step.status === 'active'
                      ? 'bg-brand-orange text-white ring-4 ring-brand-orange/20'
                      : 'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400'
                  }
                `}
              >
                {step.status === 'completed' ? (
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                ) : (
                  step.number
                )}
              </div>
              <div
                className={`
                  mt-2 text-xs font-medium text-center
                  ${
                    step.status === 'active'
                      ? 'text-brand-orange'
                      : step.status === 'completed'
                      ? 'text-green-600 dark:text-green-400'
                      : 'text-gray-500 dark:text-gray-400'
                  }
                `}
              >
                {step.title}
              </div>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                className={`
                  flex-1 h-1 mx-2 rounded transition-all duration-300
                  ${
                    steps[index + 1].status === 'completed' ||
                    steps[index + 1].status === 'active'
                      ? 'bg-green-500'
                      : 'bg-gray-200 dark:bg-gray-700'
                  }
                `}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

